<template>
  <div class="dateSelection">
    <button :class="['custom-date-picker', { 'editable': !isReadOnly }]" id="date-range-picker" @click="openDateRangePicker" tabindex="0">
      <i class="far fa-calendar-range"></i>&nbsp;
      <span id="dateRangeLabel">{{ dateText }}</span>
      <i :class="{far: true, 'fa-chevron-down': !showDateRangePicker, 'fa-chevron-up': showDateRangePicker }" v-if="!isReadOnly"></i>
    </button>
    <div ref="dateRangePicker" id="dateRangePicker" v-show="showDateRangePicker">
      <date-range-picker
          :min-date="minDate"
          :max-date="maxDate"
          :value="value"
          @range-selected="updateDateRange"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DateRangePicker from '../dateRangePicker/src/dateRangePicker.vue';

export default {
  name: 'DateRangePopup',
  props: {
    dateText: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: function() {
        return {
          startDate: undefined,
          endDate: undefined
        };
      },
    },
    minDate: {
      type: Date,
      default: function() {
        return moment().subtract(10, 'year').startOf('month').toDate();
      }
    },
    maxDate: {
      type: Date,
      default: function() {
        return moment().toDate();
      }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      showDateRangePicker: false
    };
  },
  methods: {
    outsideClickListener: function(event) {
        let self = this;
        if (self.showDateRangePicker && this.$refs.dateRangePicker && !this.$refs.dateRangePicker.contains(event.target)) {
            self.showDateRangePicker = false;
            document.removeEventListener('click', self.outsideClickListener, true);
            event.stopImmediatePropagation();
        }
    },
    openDateRangePicker: function() {
      if (!this.isReadOnly) {
        if (!this.showDateRangePicker) {
            this.showDateRangePicker = true;
            setTimeout(() => document.addEventListener('click', this.outsideClickListener.bind(this), true), 0);
        } else {
          this.showDateRangePicker = false;
        }
      }
    },
    updateDateRange(range) {
      this.showDateRangePicker = false;
      this.$emit('range-selected', range);
    }
  },
  components: {
    'date-range-picker': DateRangePicker,
  },
};
</script>
